import { useTranslation } from "react-i18next";

const audienceItems = [
  "seminars.audience.item1",
  "seminars.audience.item2",
  "seminars.audience.item3",
  "seminars.audience.item4",
  "seminars.audience.item5",
  "seminars.audience.item6",
];

export default function AudienceSection() {
  const { t } = useTranslation();

  return (
    <section className="section-padding bg-cream">
      <div className="container-main">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="tag-label mb-4 inline-block">{t("seminars.audience.label")}</span>
            <h2 className="mb-4">{t("seminars.audience.title")}</h2>
          </div>

          <div className="bg-white rounded-xl border border-warm-gray/60 p-6 md:p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {audienceItems.map((key) => (
                <div key={key} className="flex items-start gap-3 py-2">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-champagne/10 shrink-0 mt-0.5">
                    <i className="ri-check-line text-base text-champagne" />
                  </span>
                  <p className="text-graphite text-[1.0625rem] font-sans font-medium mb-0 leading-relaxed">
                    {t(key)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}